(() => {
  if (customElements.get('wohnjoy-finder')) return;
  const palettes = window.WohnjoyColors?.palettes || {light:['#f0ede5','#dbd4c7','#bdc3b7'],natural:['#d4c1a5','#b69b7c','#876d57'],dark:['#363936','#73766f','#b3ada1'],colorful:['#b5c2b0','#9caebb','#c9947e']};
  const hash = value => {
    let n = 2166136261;
    for (const char of String(value)) n = Math.imul(n ^ char.charCodeAt(0), 16777619);
    n = Math.imul(n ^ n >>> 16, 0x85ebca6b);
    n = Math.imul(n ^ n >>> 13, 0xc2b2ae35);
    return (n ^ n >>> 16) >>> 0;
  };
  const decoder = document.createElement('textarea');
  const decodeText = value => {
    let text = String(value);
    for (let pass = 0; pass < 2; pass++) text = text.replace(/&(?:#[0-9]+|#x[0-9a-f]+|[a-z][a-z0-9]+);/gi, entity => { decoder.innerHTML = entity; return decoder.value; });
    return text;
  };
  const node = (tag, className, text) => { const el = document.createElement(tag); if (className) el.className = className; if (text != null) el.textContent = decodeText(text); return el; };
  const icon = type => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    Object.entries({width: '20', height: '20', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-width': '1.5', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false'}).forEach(([key, value]) => svg.setAttribute(key, value));
    const path = document.createElementNS(svg.namespaceURI, 'path');
    path.setAttribute('d', {arrow: 'M5 12h14m-6-6 6 6-6 6', heart: 'M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z', shuffle: 'm17 3 4 4-4 4M3 7h3c5 0 7 10 12 10h3m-4-4 4 4-4 4M3 17h3c2 0 4-2 6-5m3-4c1-1 2-1 3-1h3', share: 'M12 16V3m-5 5 5-5 5 5M5 13v7h14v-7', check: 'm6 12 4 4 8-8', back: 'M19 12H5m6-6-6 6 6 6', edit: 'm16 4 4 4M4 20l5-1L21 7a2.8 2.8 0 0 0-4-4L5 15l-1 5Z', close: 'm6 6 12 12M18 6 6 18', filter: 'M4 6h5m4 0h7M4 12h10m4 0h2M4 18h3m4 0h9M9 3v6m5 0v6m-7 0v6'}[type] || 'M5 12h14');
    svg.append(path); return svg;
  };
  class WohnjoyFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      try {
        this.labels = JSON.parse(this.querySelector('[data-wj-labels]').textContent);
        const config = JSON.parse(this.querySelector('[data-wj-config]')?.textContent || '{}');
        this.hoverImages = config.hover_images === true;
        this.paletteEntries = (config.palettes || []).filter(entry => entry.id && Array.isArray(entry.colors) && entry.colors.some(color => color && CSS.supports('color',color)));
        if (!Object.hasOwn(config,'palettes')) this.paletteEntries = Object.entries(palettes).map(([id,colors]) => ({id,colors,title:this.t(id),detail:this.t(id+'_detail')}));
        this.paletteColors = Object.fromEntries(this.paletteEntries.map(entry => [entry.id,entry.colors.filter(color => color && CSS.supports('color',color))]));
        if (JSON.stringify(this.paletteColors) === JSON.stringify(palettes)) this.paletteColors = palettes;
        this.budgetEntries = (config.budgets || [250,500,1000,1500]).map(entry => typeof entry === 'number' ? {amount:entry} : entry).filter(entry => Number.isFinite(entry.amount) && entry.amount > 0 && entry.amount <= 1000000);
        this.budgets = [...new Set(this.budgetEntries.map(entry => entry.amount))];
        this.rooms = [...this.querySelectorAll('template[data-wj-room]')].map(template => ({id: template.dataset.wjRoom, title: decodeText(template.dataset.title), image: template.dataset.image || '', categories: [...template.content.querySelectorAll('[data-wj-category]')].map(a => ({id: a.dataset.wjCategory, title: decodeText(a.dataset.title), url: a.getAttribute('href'), image: a.dataset.image || ''}))})).filter(room => room.categories.length);
        this.rooms = this.rooms.filter((room, i, all) => all.findIndex(other => other.id === room.id) === i);
        const mixed = [];
        for (let index = 0; this.rooms.some(room => room.categories[index]); index++) {
          for (const room of this.rooms) if (room.categories[index]) mixed.push(room.categories[index]);
        }
        this.categories = [...new Map(mixed.map(category => [category.id, category])).values()];
        if (!this.categories.length) return;
        this.money = new Intl.NumberFormat(this.dataset.locale || 'de', {style: 'currency', currency: this.dataset.currency || 'EUR', maximumFractionDigits: 2});
        this.panel = this.querySelector('[data-wj-panel]');
        this.scroller = this.querySelector('[data-wj-scroll]');
        this.controls = this.querySelector('[data-wj-controls]');
        this.sheet = this.querySelector('[data-wj-summary]');
        this.progress = this.querySelector('[data-wj-progress]');
        this.thread = this.querySelector('[data-wj-thread]');
        this.status = this.querySelector('[data-wj-status]');
        this.cache = new Map();
        this.galleryCache = new Map();
        this.state = this.readState();
        this.sort = 'ideas';
        this.limit = 12;
        this.expanded = false;
        this.guidedEdit = false;
        this.events = new AbortController();
        this.querySelector('[data-wj-fallback]').hidden = true;
        this.querySelector('[data-wj-app]').hidden = false;
        this.thread.hidden = false;
        this.querySelector('[data-wj-action="summary"]').setAttribute('aria-label', this.t('edit_selection'));
        this.addEventListener('click', event => this.onClick(event), {signal: this.events.signal});
        this.addEventListener('pointerover', event => this.previewCardMedia(event), {signal: this.events.signal});
        this.addEventListener('pointerdown', event => { if (event.target.closest('.wj-finder__choice')) this.setAttribute('data-pointer-choice', ''); }, {signal: this.events.signal});
        this.addEventListener('keydown', () => this.removeAttribute('data-pointer-choice'), {signal: this.events.signal});
        this.addEventListener('mousedown', event => { if (event.button === 0 && event.target.closest('.wj-finder__choice')) event.preventDefault(); }, {signal: this.events.signal});
        this.addEventListener('change', event => this.onChange(event), {signal: this.events.signal});
        this.addEventListener('input', event => this.onInput(event), {signal: this.events.signal});
        if (window.Shopify?.designMode) this.addEventListener('shopify:block:select', event => { const id=event.detail?.blockId; if (this.paletteEntries.some(entry => entry.id===id)) this.go(2); else if (this.budgetEntries.some(entry => entry.id===id)) this.go(3); }, {signal:this.events.signal});
        this.scroller.addEventListener('scroll', () => { clearTimeout(this.viewTimer); this.viewTimer = setTimeout(() => this.saveView(), 500); }, {signal: this.events.signal, passive: true});
        window.addEventListener('pagehide', () => this.saveView(), {signal: this.events.signal});
        document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') this.saveView(); }, {signal: this.events.signal});
        window.addEventListener('pageshow', event => { if (event.persisted) { this.applyView(this.historyView()); this.scheduleChrome(); this.syncSaves(); } }, {signal: this.events.signal});
        window.addEventListener('popstate', () => this.restoreHistoryView(), {signal: this.events.signal});
        document.addEventListener('wohnjoy:wishlist-change', () => this.syncSaves(), {signal: this.events.signal});
        this.ready = true;
        this.setAttribute('data-ready', '');
        this.connectChrome();
        this.restoreHistoryView();
      } catch { this.disconnectedCallback(); this.querySelector('[data-wj-app]').hidden = true; this.querySelector('[data-wj-fallback]').hidden = false; }
    }
    disconnectedCallback() {
      this.restoreId = (this.restoreId || 0) + 1;
      clearTimeout(this.viewTimer);
      this.events?.abort(); this.request?.abort(); this.chromeObserver?.disconnect(); cancelAnimationFrame(this.chromeFrame); this.sheet?.close(); this.removeAttribute('data-ready'); this.ready = false;
    }
    t(key, values = {}) { return decodeText(this.labels[key] || '').replace(/\[([a-z_]+)\]/g, (match, name) => values[name] ?? match); }
    room() { return this.rooms.find(room => room.id === this.state.room); }
    availableCategories() { return this.room()?.categories || this.categories; }
    readState() {
      const params = new URL(location.href).searchParams;
      const room = this.rooms.some(item => item.id === params.get('wj_room')) ? params.get('wj_room') : '';
      const allowed = (this.rooms.find(item => item.id === room)?.categories || this.categories).map(item => item.id);
      const categories = [...new Set((params.get('wj_categories') || '').split('~').filter(id => allowed.includes(id)))];
      const budget = Number(params.get('wj_budget'));
      return {room, categories, tone: Object.hasOwn(this.paletteColors, params.get('wj_tone')) ? params.get('wj_tone') : '', budget: budget > 0 && budget <= 1000000 ? Math.round(budget * 100) / 100 : null, step: Math.min(4, Math.max(0, Number.parseInt(params.get('wj_step'), 10) || 0)), seed: Math.max(0, Number.parseInt(params.get('wj_seed'), 10) || 0) % 100000};
    }
    writeState(push = false) {
      this.restoreId = (this.restoreId || 0) + 1;
      this.restoringView = false;
      clearTimeout(this.viewTimer);
      const url = new URL(location.href);
      for (const [key, value] of Object.entries({room: this.state.room, categories: this.state.categories.join('~'), tone: this.state.tone, budget: this.state.budget, step: this.state.step, seed: this.state.seed})) {
        if (value === '' || value === null || value === 0) url.searchParams.delete('wj_' + key); else url.searchParams.set('wj_' + key, String(value));
      }
      if (push) this.historyKey = this.newHistoryKey();
      history[push ? 'pushState' : 'replaceState']({...history.state, wohnjoyFinder: this.captureView(url.href)}, '', url);
      this.historyUrl = url.href;
    }
    newHistoryKey() { return crypto.randomUUID?.() || Date.now().toString(36) + Math.random().toString(36).slice(2); }
    historyView() {
      const view = history.state?.wohnjoyFinder;
      return view?.version === 1 && typeof view.key === 'string' && view.url === location.href ? view : null;
    }
    captureView(url = location.href) {
      const bounds = this.scroller.getBoundingClientRect();
      const visible = [...this.panel.querySelectorAll('.wj-finder__product')].find(card => { const box = card.getBoundingClientRect(); return box.bottom > bounds.top && box.top < bounds.bottom; });
      return {version: 1, key: this.historyKey, url, scrollTop: this.scroller.scrollTop, limit: this.limit, sort: this.sort, expanded: this.expanded, anchor: visible ? {productId: visible.dataset.productId, offset: visible.getBoundingClientRect().top - bounds.top} : null};
    }
    saveView() {
      if (!this.ready || this.restoringView || location.href !== this.historyUrl) return;
      clearTimeout(this.viewTimer);
      try { history.replaceState({...history.state, wohnjoyFinder: this.captureView()}, ''); } catch {}
    }
    applyView(view) {
      if (!view || view.key !== this.historyKey || view.url !== location.href) return;
      this.scroller.scrollTop = Number.isFinite(view.scrollTop) ? Math.max(0, view.scrollTop) : 0;
      if (!view.anchor || !Number.isFinite(view.anchor.offset)) return;
      const card = [...this.panel.querySelectorAll('.wj-finder__product')].find(card => card.dataset.productId === view.anchor.productId);
      if (card) this.scroller.scrollTop += card.getBoundingClientRect().top - this.scroller.getBoundingClientRect().top - view.anchor.offset;
    }
    async restoreHistoryView() {
      const view = this.historyView();
      if (view && view.key === this.historyKey && location.href === this.historyUrl) return;
      const restoreId = this.restoreId = (this.restoreId || 0) + 1;
      this.restoringView = true;
      clearTimeout(this.viewTimer);
      this.request?.abort();
      this.loading = false;
      this.isEditing = false;
      this.guidedEdit = false;
      this.sheet.close();
      this.state = this.readState();
      this.historyKey = view?.key || this.newHistoryKey();
      this.historyUrl = location.href;
      this.sort = ['ideas', 'price-up', 'price-down'].includes(view?.sort) ? view.sort : 'ideas';
      this.limit = Number.isSafeInteger(view?.limit) && view.limit >= 12 ? view.limit : 12;
      this.expanded = view?.expanded === true;
      this.render();
      this.scroller.scrollTop = 0;
      if (this.state.step === 4) await this.loadResults();
      if (restoreId !== this.restoreId || !this.isConnected) return;
      this.applyView(view);
      await new Promise(requestAnimationFrame);
      if (restoreId !== this.restoreId || !this.isConnected) return;
      this.applyView(view);
      this.restoringView = false;
      this.saveView();
    }
    button(text, action, className = 'wj-finder__button') { const button = node('button', className, text); button.type = 'button'; button.dataset.wjAction = action; return button; }
    link(text, url, className) { const a = node('a', className, text); a.href = this.safeUrl(url); return a; }
    safeUrl(value, image = false) {
      try { const url = new URL(value, location.origin); if (!['http:', 'https:'].includes(url.protocol)) return ''; if (!image && url.origin !== location.origin) return ''; return url.href; } catch { return ''; }
    }
    connectChrome() {
      const update = () => this.scheduleChrome();
      this.cardMedia = matchMedia('(max-width:749px), (max-width:1024px) and (max-height:500px)');
      this.cardMedia.addEventListener('change', () => {
        this.panel.querySelectorAll('.wj-finder__product').forEach(card => {
          const picker = card.querySelector('.wj-finder__variants');
          if (picker) card.querySelector(this.cardMedia.matches ? '.wj-finder__product-info' : '.product-item__inner').append(picker);
        });
      }, {signal: this.events.signal});
      this.chromeObserver = new ResizeObserver(update);
      this.chromeObserver.observe(this.querySelector('.wj-finder__intro'));
      const header = document.querySelector('.section-header');
      if (header) this.chromeObserver.observe(header);
      window.addEventListener('resize', update, {signal: this.events.signal, passive: true});
      window.addEventListener('scroll', update, {signal: this.events.signal, passive: true});
      window.visualViewport?.addEventListener('resize', update, {signal: this.events.signal, passive: true});
      window.visualViewport?.addEventListener('scroll', update, {signal: this.events.signal, passive: true});
      this.addEventListener('focusin', update, {signal: this.events.signal});
      this.addEventListener('focusout', update, {signal: this.events.signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target.name === 'wj-custom-budget' && this.validBudget()) { event.preventDefault(); this.go(4); }
      }, {signal: this.events.signal});
      this.sheet.addEventListener('click', event => {
        if (event.target !== this.sheet) return;
        const box = this.sheet.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.sheet.close();
      }, {signal: this.events.signal});
      this.scheduleChrome();
    }
    scheduleChrome() {
      cancelAnimationFrame(this.chromeFrame);
      this.chromeFrame = requestAnimationFrame(() => {
        if (!this.isConnected) return;
        const viewport = window.visualViewport;
        const height = viewport?.height || innerHeight;
        const offset = viewport?.offsetTop || 0;
        const top = Math.max(0, this.querySelector('[data-wj-app]').getBoundingClientRect().top) - offset;
        this.style.setProperty('--wj-app-top', Math.round(top) + 'px');
        this.style.setProperty('--wj-viewport-height', Math.round(height) + 'px');
        const keyboard = document.activeElement?.name === 'wj-custom-budget' && innerHeight - height > 100;
        this.toggleAttribute('data-keyboard', keyboard);
        if (keyboard) {
          const field = document.activeElement.getBoundingClientRect();
          const visible = this.scroller.getBoundingClientRect();
          if (field.bottom > visible.bottom - 12) this.scroller.scrollBy({top: field.bottom - visible.bottom + 20, behavior: 'instant'});
          else if (field.top < visible.top + 12) this.scroller.scrollBy({top: field.top - visible.top - 20, behavior: 'instant'});
        }
      });
    }
    heading(key, description, result = false) {
      const meta = node('div', 'wj-finder__question-meta');
      meta.append(node('span', '', result ? this.t('results_meta') : this.t('step_label', {current: this.state.step + 1})));
      if (!result) meta.append(this.button(this.t('show_now'), 'results', 'wj-finder__text-action'));
      const heading = node('h2', '', this.t(key));
      heading.tabIndex = -1; heading.id = 'FinderHeading-' + (this.closest('.shopify-section')?.id || this.id || 'main');
      const content = [meta, heading, node('p', 'wj-finder__description', this.t(description))];
      if (result) this.panel.append(...content);
      else { const header = node('div', 'wj-finder__question-header'); header.append(...content); this.panel.append(header); }
      return heading;
    }
    choices(name, items, value, multiple = false) {
      const fieldset = node('fieldset', 'wj-finder__fieldset');
      fieldset.setAttribute('aria-labelledby', this.panel.querySelector('h2').id);
      const grid = node('div', 'wj-finder__choices');
      items.forEach((item, index) => {
        const label = node('label', 'wj-finder__choice' + (item.open ? ' wj-finder__choice--open' : !item.image && !item.palette ? ' wj-finder__choice--plain' : ''));
        const editor = [...this.querySelectorAll('[data-wj-editor-block]')].find(template => template.dataset.wjEditorBlock === item.blockId)?.getAttribute('data-shopify-editor-block');
        if (editor) label.setAttribute('data-shopify-editor-block',editor);
        const input = node('input'); input.type = multiple ? 'checkbox' : 'radio'; input.name = 'wj-' + name; input.value = item.id;
        input.checked = multiple ? (item.id ? value.includes(item.id) : value.length === 0) : item.id === value;
        const face = node('span', 'wj-finder__choice-face');
        const mark = node('span', 'wj-finder__choice-mark'); mark.setAttribute('aria-hidden', 'true'); mark.append(icon('check')); face.append(mark);
        if (item.image && this.safeUrl(item.image, true)) {
          const image = node('img', 'wj-finder__choice-image'); image.src = this.safeUrl(item.image, true); image.alt = ''; image.width = 600; image.height = 400;
          image.addEventListener('error', () => { label.classList.add('wj-finder__choice--plain'); image.remove(); }, {once: true});
          image.loading = index < 4 ? 'eager' : 'lazy'; image.decoding = 'async'; face.append(image);
        }
        if (item.palette) {
          const colors = node('span', 'wj-finder__palette'); colors.setAttribute('aria-hidden', 'true');
          item.palette.forEach(color => { const swatch = node('span'); swatch.style.backgroundColor = color; colors.append(swatch); }); face.append(colors);
        }
        const copy = node('span', 'wj-finder__choice-copy'); copy.append(node('span', 'wj-finder__choice-title', item.title));
        if (item.detail) copy.append(node('span', 'wj-finder__choice-detail', item.detail));
        face.append(copy); label.append(input, face); grid.append(label);
      });
      fieldset.append(grid); this.panel.append(fieldset); return grid;
    }
    render() {
      this.toggleAttribute('data-results', this.state.step === 4);
      this.panel.dataset.question = String(this.state.step);
      this.progress.replaceChildren();
      ['room', 'category', 'tone', 'budget'].forEach((step, index) => {
        const button = this.button('', 'step', ''); button.dataset.step = index;
        const number = node('span', 'wj-finder__progress-number', String(index + 1)); number.setAttribute('aria-hidden', 'true');
        button.append(number, node('span', '', this.t('step_' + step)));
        if (index === this.state.step) button.setAttribute('aria-current', 'step');
        if (index < this.state.step) button.dataset.complete = '';
        this.progress.append(button);
      });
      this.renderThread(); this.renderControls();
      this.panel.replaceChildren(); this.panel.removeAttribute('aria-busy');
      if (this.state.step === 4) { this.heading('results_heading', 'results_desc', true); return; }
      if (this.state.step === 0) {
        this.heading('room_heading', 'room_desc');
        this.choices('room', [...this.rooms, {id: '', title: this.t('open_room'), open: true}], this.state.room);
      } else if (this.state.step === 1) {
        this.heading('category_heading', 'category_desc');
        const categories = this.availableCategories();
        const selected = categories.filter(item => this.state.categories.includes(item.id));
        const shown = this.expanded ? categories : [...new Map([...categories.slice(0, 8), ...selected].map(item => [item.id, item])).values()];
        this.choices('categories', [...shown, {id: '', title: this.t('open_category'), open: true}], this.state.categories, true);
        if (!this.expanded && categories.length > shown.length) this.panel.append(this.button(this.t('more_choices'), 'expand', 'wj-finder__more-choices'));
      } else if (this.state.step === 2) {
        this.heading('tone_heading', 'tone_desc');
        const grid = this.choices('tone', [...this.paletteEntries.map(entry => ({id:entry.id,blockId:entry.id,title:entry.title || this.t(entry.id),detail:entry.detail,palette:this.paletteColors[entry.id]})), {id: '', title: this.t('open_tone'), open: true}], this.state.tone);
        grid.classList.add('wj-finder__choices--tones');
      } else {
        this.heading('budget_heading', 'budget_desc');
        const grid = this.choices('budget', [...this.budgets.map(amount => ({id: String(amount), blockId:this.budgetEntries.find(entry => entry.amount===amount)?.id, title: this.t('budget_up_to', {amount: this.money.format(amount)}), detail: this.t('per_item')})), {id: '', title: this.t('open_budget'), open: true}], this.state.budget === null ? '' : String(this.state.budget));
        grid.classList.add('wj-finder__budget-options');
        const custom = node('div', 'wj-finder__budget-custom'); const label = node('label', '', this.t('budget_custom')); const input = node('input');
        input.id = 'FinderBudget-' + (this.closest('.shopify-section')?.id || this.id || 'main'); label.htmlFor = input.id;
        input.name = 'wj-custom-budget'; input.type = 'number'; input.inputMode = 'decimal'; input.min = '0.01'; input.max = '1000000'; input.step = '0.01'; input.placeholder = this.t('budget_placeholder');
        if (this.state.budget !== null) input.value = String(this.state.budget);
        custom.append(label, input, node('span', '', this.dataset.currency || 'EUR')); this.panel.append(custom);
        const error = node('p', 'wj-finder__error', this.t('budget_error')); error.id = input.id + '-error'; error.hidden = true; error.setAttribute('role', 'alert'); input.setAttribute('aria-describedby', error.id); this.panel.append(error);
      }
    }
    summaryEntries() {
      return [
        {label: this.t('step_room'), value: this.room()?.title || this.t('open_room'), step: 0, active: Boolean(this.state.room)},
        {label: this.t('step_category'), value: this.state.categories.map(id => this.categories.find(item => item.id === id)?.title).filter(Boolean).join(', ') || this.t('open_category'), step: 1, active: Boolean(this.state.categories.length)},
        {label: this.t('step_tone'), value: this.state.tone ? this.paletteEntries.find(entry => entry.id === this.state.tone)?.title || this.t(this.state.tone) : this.t('open_tone'), step: 2, active: Boolean(this.state.tone)},
        {label: this.t('step_budget'), value: this.state.budget !== null ? this.t('budget_up_to', {amount: this.money.format(this.state.budget)}) : this.t('open_budget'), step: 3, active: this.state.budget !== null}
      ];
    }
    summaryList() {
      const list = node('div', 'wj-finder__summary-list');
      for (const entry of this.summaryEntries()) {
        const button = this.button('', 'step', 'wj-finder__summary-row'); button.dataset.step = entry.step;
        const copy = node('span'); copy.append(node('span', 'wj-finder__summary-label', entry.label), node('span', 'wj-finder__summary-value', entry.value));
        button.append(copy, icon('edit')); button.setAttribute('aria-label', entry.label + ': ' + entry.value + '. ' + this.t('edit')); list.append(button);
      }
      return list;
    }
    renderThread() {
      this.thread.replaceChildren(node('p', 'wj-finder__thread-heading', this.t('selection')), this.summaryList(), node('p', 'wj-finder__summary-note', this.t('selection_note')));
      this.querySelector('[data-wj-summary-content]').replaceChildren(this.summaryList());
      const count = this.summaryEntries().filter(entry => entry.active).length;
      this.querySelector('[data-wj-selection-count]').textContent = String(count);
      this.querySelector('[data-wj-action="summary"]').setAttribute('aria-label', this.t('selection_count', {count}));
    }
    renderControls() {
      const start = node('div', 'wj-finder__control-start'); const actions = node('div', 'wj-finder__control-actions');
      if (this.state.step === 4) {
        const edit = this.button(this.t('edit_selection'), 'summary', 'wj-finder__button wj-finder__button--secondary'); edit.prepend(icon('filter')); start.append(edit);
        const next = this.button(this.t(this.loading ? 'loading_short' : 'new_ideas'), 'new'); next.prepend(icon('shuffle')); next.disabled = Boolean(this.loading); actions.append(next);
      } else {
        const quickEdit = this.isEditing && !this.guidedEdit;
        if (this.isEditing) { const cancel = this.button(this.t('cancel'), 'cancel-edit', 'wj-finder__back'); cancel.prepend(icon('back')); start.append(cancel); }
        else if (this.state.step) { const back = this.button(this.t('back'), 'back', 'wj-finder__back'); back.prepend(icon('back')); start.append(back); }
        else start.append(node('span', 'wj-finder__control-context', this.t('start_hint')));
        if (!quickEdit && this.state.step < 3) actions.append(this.button(this.t('skip'), 'skip', 'wj-finder__text-action wj-finder__skip'));
        const next = this.button(this.t(quickEdit ? 'apply' : this.state.step === 3 ? 'show_ideas' : 'next'), quickEdit ? 'results' : 'next'); next.append(icon('arrow')); actions.append(next);
      }
      this.controls.replaceChildren(start, actions);
    }
    async go(step) {
      if (this.navigating) return;
      this.saveView();
      this.navigating = true;
      if (this.state.step === 4 && step < 4) { this.editSnapshot = {...this.state, categories: [...this.state.categories]}; this.isEditing = true; }
      if (this.isEditing && step === 0) this.guidedEdit = true;
      if (step === 4) { this.isEditing = false; this.guidedEdit = false; }
      this.loading = false;
      this.sheet.close();
      if (step !== 4) this.request?.abort();
      this.state.step = step; this.limit = 12; this.writeState(true);
      const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.panel.getAnimations().forEach(animation => animation.cancel());
      this.render(); this.scroller.scrollTop = 0;
      if (!reduced) this.panel.animate([{opacity: .2}, {opacity: 1}], {duration: 180, easing: 'ease-out'});
      this.navigating = false;
      this.focusHeading();
      this.dispatchEvent(new CustomEvent('wohnjoy:finder', {bubbles: true, detail: {action: step === 4 ? 'results' : 'step', step}}));
      this.saveView();
      if (step === 4) this.loadResults();
    }
    focusHeading() {
      this.scroller.scrollTop = 0;
      this.panel.querySelector('h2')?.focus({preventScroll: true});
    }
    onChange(event) {
      const input = event.target;
      if (input.name === 'wj-room') { if (this.state.room !== input.value) { this.state.room = input.value; this.state.categories = []; this.expanded = false; } }
      else if (input.name === 'wj-categories') {
        if (!input.value) this.state.categories = [];
        else this.state.categories = input.checked ? [...new Set([...this.state.categories, input.value])] : this.state.categories.filter(id => id !== input.value);
        this.panel.querySelectorAll('[name="wj-categories"]').forEach(choice => { choice.checked = choice.value ? this.state.categories.includes(choice.value) : this.state.categories.length === 0; });
      } else if (input.name === 'wj-tone') this.state.tone = input.value;
      else if (input.name === 'wj-budget') {
        this.state.budget = input.value ? Number(input.value) : null;
        this.panel.querySelector('[name="wj-custom-budget"]').value = input.value;
        this.panel.querySelector('.wj-finder__error').hidden = true;
        this.panel.querySelector('[name="wj-custom-budget"]').removeAttribute('aria-invalid');
      } else if (input.name === 'wj-sort') { this.sort = input.value; this.limit = 12; this.renderProducts(true); return; }
      else return;
      this.writeState(); this.renderThread(); this.renderControls();
    }
    onInput(event) {
      if (event.target.name !== 'wj-custom-budget') return;
      const input = event.target;
      const valid = !input.validity.badInput && (input.value === '' || input.checkValidity());
      this.panel.querySelector('.wj-finder__error').hidden = valid;
      input.setAttribute('aria-invalid', String(!valid));
      this.state.budget = valid && input.value !== '' ? Number(input.value) : null;
      this.panel.querySelectorAll('[name="wj-budget"]').forEach(choice => { choice.checked = valid && (choice.value ? Number(choice.value) === this.state.budget : this.state.budget === null); });
      this.writeState(); this.renderThread(); this.renderControls();
    }
    validBudget() {
      const input = this.panel.querySelector('[name="wj-custom-budget"]');
      if (!input || (!input.validity.badInput && (input.value === '' || input.checkValidity()))) return true;
      this.panel.querySelector('.wj-finder__error').hidden = false; input.setAttribute('aria-invalid', 'true'); input.focus(); return false;
    }
    onClick(event) {
      if (event.target.closest('a[href]')) this.saveView();
      const choice = event.target.closest('.wj-finder__choice');
      if (choice && this.contains(choice) && event.target.tagName !== 'INPUT') {
        event.preventDefault();
        const input = choice.querySelector('input');
        input.focus({preventScroll: true});
        input.click();
        return;
      }
      const target = event.target.closest('[data-wj-action]'); if (!target || !this.contains(target)) return;
      this.saveView();
      const action = target.dataset.wjAction;
      if (action === 'next' && this.validBudget()) this.go(this.state.step + 1);
      else if (action === 'back') this.go(Math.max(0, this.state.step - 1));
      else if (action === 'step') this.go(Number(target.dataset.step));
      else if (action === 'summary') { this.renderThread(); this.sheet.showModal(); }
      else if (action === 'close-summary') this.sheet.close();
      else if (action === 'cancel-edit') { if (this.editSnapshot) this.state = {...this.editSnapshot, categories: [...this.editSnapshot.categories]}; this.isEditing = false; this.go(4); }
      else if (action === 'skip') { if (this.state.step === 0) { this.state.room = ''; this.state.categories = []; } else if (this.state.step === 1) this.state.categories = []; else if (this.state.step === 2) this.state.tone = ''; this.go(this.state.step + 1); }
      else if (action === 'results' && this.validBudget()) this.go(4);
      else if (action === 'expand') { this.expanded = true; this.render(); this.panel.querySelectorAll('[name="wj-categories"]')[8]?.focus(); this.saveView(); }
      else if (action === 'retry') this.loadResults();
      else if (action === 'remove-budget') { this.state.budget = null; this.writeState(true); this.renderThread(); this.renderProducts(); }
      else if (action === 'broaden') { this.state.categories = []; this.writeState(true); this.renderThread(); this.loadResults(); }
      else if (action === 'new') this.shuffleResults();
      else if (action === 'more') this.appendProducts();
      else if (action === 'direction') { this.state.categories = [target.dataset.category]; this.writeState(true); this.limit = 12; this.renderThread(); this.loadResults(); this.focusHeading(); }
      else if (action === 'restart') { this.state = {room: '', categories: [], tone: '', budget: null, step: 0, seed: 0}; this.expanded = false; this.isEditing = false; this.go(0); }
      else if (action === 'save') this.save(target);
      else if (action === 'variant') {
        const card = target.closest('.wj-finder__product');
        const item = card?.finderItem;
        const variant = item?.product.variants.find(variant => variant.id === target.dataset.variantId);
        if (!variant || (this.state.budget !== null && variant.price > this.state.budget * 100)) return;
        const top = this.scroller.scrollTop;
        const replacement = this.productCard({...item, variant});
        card.replaceWith(replacement);
        this.syncSaves();
        replacement.querySelector('[data-wj-action="variant"][aria-pressed="true"]')?.focus({preventScroll: true});
        this.scroller.scrollTop = top;
      }
      else if (action === 'share') this.share(target);
    }
    scopes() {
      const available = this.availableCategories();
      if (this.state.categories.length) return available.filter(item => this.state.categories.includes(item.id));
      const offset = this.state.seed * 4 % available.length;
      return [...available.slice(offset), ...available.slice(0, offset)].slice(0, 4);
    }
    async fetchPage(category, page, signal) {
      const url = new URL(this.safeUrl(category.url));
      url.searchParams.set('view', 'wohnjoy-finder-data'); url.searchParams.set('page', String(page)); url.searchParams.set('sort_by', 'best-selling');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
      const requestSignal = typeof AbortSignal.any === 'function' && typeof AbortSignal.timeout === 'function' ? AbortSignal.any([signal, AbortSignal.timeout(15000)]) : signal;
      const response = await fetch(url, {signal: requestSignal, credentials: 'same-origin', headers: {Accept: 'text/html'}});
      if (!response.ok) throw new Error('Response unavailable');
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = JSON.parse(document.querySelector('[data-wj-finder-products]')?.textContent || 'null');
      if (!data || data.handle !== category.id || !Array.isArray(data.products) || Number(data.page) !== page || !Number.isInteger(data.pages) || data.pages < 0) throw new Error('Invalid catalog');
      return data;
    }
    async fetchCategory(category, exhaustive, signal) {
      const cached = this.cache.get(category.id);
      if (cached && (!exhaustive || cached.complete)) return cached;
      const first = cached?.first || await this.fetchPage(category, 1, signal);
      const products = [...first.products];
      const pages = exhaustive ? Math.min(40, first.pages) : 1;
      let next = 2;
      const worker = async () => { while (next <= pages) { const page = next++; const data = await this.fetchPage(category, page, signal); products.push(...data.products); } };
      if (exhaustive) await Promise.all([worker(), worker()]);
      const result = {first, products, complete: first.pages <= pages, limited: first.pages > pages};
      this.cache.set(category.id, result); return result;
    }
    async shuffleResults() {
      if (this.loading || this.state.step !== 4) return;
      this.saveView();
      const scrollTop = this.scroller.scrollTop;
      const seed = this.state.seed = (this.state.seed + 1) % 100000;
      this.sort = 'ideas';
      this.writeState(true);
      await this.loadResults({keepResults: true});
      if (this.state.step !== 4 || this.state.seed !== seed || this.loading || !this.isConnected) return;
      this.scroller.scrollTop = scrollTop;
      this.controls.querySelector('[data-wj-action="new"]')?.focus({preventScroll: true});
      this.saveView();
    }
    async loadResults({keepResults = false} = {}) {
      this.request?.abort();
      const request = new AbortController(); this.request = request;
      const scopes = this.scopes(); const exhaustive = this.state.categories.length > 0;
      const cached = scopes.map(category => ({category, data: this.cache.get(category.id)}));
      if (cached.every(group => group.data && (!exhaustive || group.data.complete))) {
        this.loading = false; this.loaded = cached; this.renderProducts(); return;
      }
      this.loading = true;
      if (keepResults && this.panel.querySelector('.wj-finder__product')) {
        this.renderControls(); this.panel.setAttribute('aria-busy', 'true'); this.status.textContent = this.t('loading');
      } else {
        this.render(); this.panel.setAttribute('aria-busy', 'true');
        const loading = node('p', 'wj-finder__loading', this.t('loading')); loading.setAttribute('role', 'status'); this.panel.append(loading);
        const skeletons = node('div', 'wj-finder__products'); skeletons.setAttribute('aria-hidden', 'true'); for (let i = 0; i < 4; i++) skeletons.append(node('div', 'wj-finder__skeleton')); this.panel.append(skeletons);
      }
      const results = []; let index = 0;
      const worker = async () => { while (index < scopes.length) { const category = scopes[index++]; try { const data = await this.fetchCategory(category, exhaustive, request.signal); results.push({category, data}); } catch (error) { if (request.signal.aborted) throw error; results.push({category, error: true}); } } };
      try { await Promise.all([worker(), worker()]); } catch { return; }
      if (request.signal.aborted || this.state.step !== 4 || !this.isConnected) return;
      this.loading = false;
      this.loaded = results.sort((a, b) => scopes.indexOf(a.category) - scopes.indexOf(b.category)); this.renderProducts();
    }
    candidates() {
      const best = new Map();
      for (const group of this.loaded || []) {
        if (!group.data) continue;
        for (const product of group.data.products) {
          if (!/^\d+$/.test(product.id) || !Array.isArray(product.variants)) continue;
          const variants = product.variants.filter(variant => /^\d+$/.test(variant.id) && Number.isFinite(variant.price) && variant.price >= 0 && (this.state.budget === null || variant.price <= Math.round(this.state.budget * 100)));
          const score = variant => {
            if (!this.state.tone) return 0;
            return window.WohnjoyColors?.families(variant.color, variant.color_rgb, this.paletteColors).includes(this.state.tone) ? 2 : 0;
          };
          variants.sort((a, b) => score(b) - score(a) || a.price - b.price);
          if (!variants.length || !this.safeUrl(product.url)) continue;
          const variant = variants[0];
          const item = {product, variant, category: group.category, score: score(variant), rank: hash(product.id + ':' + this.state.seed)};
          const previous = best.get(product.id); if (!previous || previous.score < item.score) best.set(product.id, item);
        }
      }
      const candidates = [...best.values()];
      if (this.sort !== 'ideas') return candidates.sort((a, b) => this.sort === 'price-up' ? a.variant.price - b.variant.price : b.variant.price - a.variant.price);
      const groups = new Map();
      candidates.sort((a, b) => b.score - a.score || a.rank - b.rank).forEach(item => { if (!groups.has(item.category.id)) groups.set(item.category.id, []); groups.get(item.category.id).push(item); });
      const result = [];
      while (result.length < candidates.length) for (const group of groups.values()) if (group.length) result.push(group.shift());
      return result;
    }
    renderProducts(restoreSortFocus = false) {
      this.render();
      const failed = (this.loaded || []).filter(group => group.error).length;
      const candidates = this.candidates();
      if (failed) {
        const notice = node('div', 'wj-finder__result-note'); notice.append(node('p', '', this.t('load_error')), this.button(this.t('retry'), 'retry', 'wj-finder__text-action')); this.panel.append(notice);
      }
      if (!candidates.length) {
        const empty = node('div', 'wj-finder__empty'); empty.append(node('h3', '', this.t(failed ? 'load_error' : 'empty_heading')), node('p', '', this.t(failed ? 'error_desc' : 'empty_desc')));
        const actions = node('div', 'wj-finder__empty-actions');
        if (this.state.budget !== null && !failed) actions.append(this.button(this.t('remove_budget'), 'remove-budget'));
        if (this.state.categories.length && !failed) actions.append(this.button(this.t('broaden_categories'), 'broaden', 'wj-finder__button wj-finder__button--secondary'));
        if (failed) actions.append(this.button(this.t('retry'), 'retry'));
        actions.append(this.link(this.t('browse'), this.dataset.allUrl, 'wj-finder__button wj-finder__button--secondary')); empty.append(actions); this.panel.append(empty); this.renderExplore();
        this.status.textContent = this.t(failed ? 'load_error' : 'empty_heading'); return;
      }
      const toolbar = node('div', 'wj-finder__result-toolbar');
      toolbar.append(node('span', '', this.t('results_toolbar')));
      const label = node('label'); label.append(node('span', '', this.t('sort'))); const sort = node('select'); sort.name = 'wj-sort'; sort.setAttribute('aria-label', this.t('sort'));
      ['ideas', 'price-up', 'price-down'].forEach((value, i) => { const option = node('option', '', this.t(['sort_ideas', 'sort_price_up', 'sort_price_down'][i])); option.value = value; sort.append(option); }); sort.value = this.sort; label.append(sort); toolbar.append(label); this.panel.append(toolbar);
      if (this.state.tone) this.panel.append(node('p', 'wj-finder__result-note', this.t('results_tone_note')));
      if ((this.loaded || []).some(group => group.data?.limited)) this.panel.append(node('p', 'wj-finder__result-note', this.t('results_partial')));
      const grid = node('div', 'wj-finder__products');
      candidates.slice(0, this.limit).forEach(item => grid.append(this.productCard(item))); this.panel.append(grid);
      if (candidates.length > this.limit) this.panel.append(this.button(this.t('show_more'), 'more', 'wj-finder__button wj-finder__button--secondary wj-finder__load-more'));
      this.panel.append(node('p', 'wj-finder__price-note', this.t('prices')));
      const actions = node('div', 'wj-finder__result-links');
      const share = this.button(this.t('share'), 'share', 'wj-finder__text-action'); share.prepend(icon('share')); actions.append(share, this.button(this.t('restart'), 'restart', 'wj-finder__text-action')); this.panel.append(actions);
      this.renderExplore(); this.syncSaves(); this.status.textContent = this.t('ideas_ready');
      if (restoreSortFocus) this.panel.querySelector('[name="wj-sort"]')?.focus({preventScroll: true});
      this.saveView();
    }
    appendProducts() {
      const grid = this.panel.querySelector('.wj-finder__products');
      if (!grid || this.loading) return;
      const candidates = this.candidates();
      const index = this.limit;
      const added = candidates.slice(index, index + 12);
      if (!added.length) return;
      const scrollTop = this.scroller.scrollTop;
      this.limit += added.length;
      grid.append(...added.map(item => this.productCard(item)));
      if (this.limit >= candidates.length) this.panel.querySelector('[data-wj-action="more"]')?.remove();
      this.syncSaves();
      grid.children[index]?.querySelector('h3 a')?.focus({preventScroll: true});
      this.scroller.scrollTop = scrollTop;
      this.status.textContent = this.t('more_ready', {count: added.length});
      this.saveView();
    }
    async cardGallery(product) {
      if (this.galleryCache.has(product.id)) return this.galleryCache.get(product.id);
      const pending = (async () => {
        const url = new URL(this.safeUrl(product.url));
        url.searchParams.set('view', 'wohnjoy-card-gallery');
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview && /^\d+$/.test(preview)) url.searchParams.set('preview_theme_id', preview);
        const signal = typeof AbortSignal.any === 'function' && typeof AbortSignal.timeout === 'function' ? AbortSignal.any([this.events.signal, AbortSignal.timeout(15000)]) : this.events.signal;
        const response = await fetch(url, {signal, credentials: 'same-origin', headers: {Accept: 'text/html'}});
        if (!response.ok) throw new Error('Gallery unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const gallery = document.querySelector('[data-wj-card-media]');
        if (gallery?.dataset.productId !== product.id) throw new Error('Invalid product gallery');
        const data = JSON.parse(gallery.querySelector('[data-wj-card-gallery]')?.textContent || 'null');
        if (!data || !Array.isArray(data.images)) throw new Error('Invalid product gallery');
        return data;
      })();
      this.galleryCache.set(product.id, pending);
      try { return await pending; }
      catch (error) { if (this.galleryCache.get(product.id) === pending) this.galleryCache.delete(product.id); throw error; }
    }
    async previewCardMedia(event) {
      if (!this.hoverImages || event.pointerType === 'touch' || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
      const card = event.target.closest('.wj-finder__product');
      const media = card?.querySelector('.wj-finder__product-media');
      if (!card || !this.contains(card) || card.mediaReady || card.mediaPending || !media?.contains(event.target) || media.contains(event.relatedTarget)) return;
      const item = card.finderItem;
      if (!item || !window.WohnjoyCardMedia?.select) return;
      card.mediaPending = true;
      try {
        const data = await this.cardGallery(item.product);
        if (!this.isConnected || !card.isConnected || !media.matches(':hover') || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
        const gallery = node('script'); gallery.type = 'application/json'; gallery.dataset.wjCardGallery = ''; gallery.textContent = JSON.stringify(data);
        const host = card.querySelector('.wj-card-variants') || card;
        host.dataset.wjHoverEnabled = 'true'; host.append(gallery);
        window.WohnjoyCardMedia.select(card, {image: item.variant.image || item.product.image, variantId: item.variant.id, label: item.variant.color});
        card.mediaReady = true;
      } catch {} finally { card.mediaPending = false; }
    }
    productCard({product, variant, category}) {
      const url = new URL(this.safeUrl(product.url)); url.searchParams.set('variant', variant.id);
      const card = node('article', 'wj-finder__product wj-card-surface wj-card-grid'); card.dataset.productId = product.id;
      card.finderItem = {product, variant, category};
      card.dataset.wjHoverEnabled = String(this.hoverImages);
      const wrapper = node('div', 'product-item__wrapper');
      const imageBox = node('div', 'product-item__inner');
      const media = this.link('', url, 'wj-finder__product-media product__media'); media.tabIndex = -1; media.setAttribute('aria-hidden', 'true');
      const imageUrl = this.safeUrl(variant.image || product.image, true);
      if (imageUrl) { const image = node('img', 'first-image'); image.src = imageUrl; image.alt = ''; image.width = 720; image.height = 720; image.loading = 'lazy'; image.decoding = 'async'; media.append(image); }
      else { media.append(icon('arrow')); }
      imageBox.append(media);
      const info = node('div', 'wj-finder__product-info product-item__information');
      const heading = node('h3', 'product-item__name'); heading.append(this.link(String(product.title || ''), url)); info.append(heading);
      if (window.WohnjoyWishlist) { const save = this.button('', 'save', 'wj-finder__save wj-card-save'); save.dataset.productId = product.id; save.dataset.variantId = variant.id; save.append(icon('heart')); info.append(save); }
      const bottom = node('div', 'wj-finder__product-bottom wj-card-price-row'); bottom.append(node('span', 'wj-finder__price product-item__price', this.money.format(variant.price / 100)));
      const view = this.link('', url, 'wj-finder__product-view wj-card-view'); view.append(icon('arrow')); view.setAttribute('aria-label', this.t('view_product', {product: String(product.title || '')})); bottom.append(view); info.append(bottom);
      info.append(node('p', 'wj-mobile-card-note', this.t('card_note')));
      const colorLabel = String(variant.color || '').trim();
      if (colorLabel.length <= 80 && /\p{L}/u.test(colorLabel) && !/[<>]/.test(colorLabel)) info.append(node('p', 'wj-finder__product-color wj-mobile-card-color', this.t('product_color', {color: colorLabel})));
      const options = [...new Map(product.variants.filter(option => option.color && (this.state.budget === null || option.price <= this.state.budget * 100)).map(option => [option.color, option])).values()];
      if (options.length > 1) {
        const picker = node('div', 'wj-finder__variants wj-card-variants'); picker.setAttribute('role', 'group'); picker.setAttribute('aria-label', this.t('step_tone'));
        const shown = options.slice(0, 4);
        if (!shown.some(option => option.id === variant.id)) shown[shown.length - 1] = variant;
        shown.forEach(option => {
          const button = this.button('', 'variant', 'wj-card-variant'); button.dataset.variantId = option.id; button.setAttribute('aria-pressed', String(option.id === variant.id)); button.setAttribute('aria-label', this.t('choose_color', {color: option.color})); button.title = option.color;
          const preview = this.safeUrl(option.image || product.image, true);
          if (preview) { const image = node('img'); const thumb = new URL(preview); if (thumb.searchParams.has('width')) thumb.searchParams.set('width', '120'); image.src = thumb.href; image.alt = ''; image.width = 36; image.height = 36; image.loading = 'lazy'; image.decoding = 'async'; button.append(image); }
          else button.append(node('span', '', option.color));
          picker.append(button);
        });
        if (options.length > shown.length) picker.append(this.link('+' + (options.length - shown.length), url, 'wj-card-more'));
        (this.cardMedia.matches ? info : imageBox).append(picker);
      }
      wrapper.append(imageBox, info); card.append(wrapper); return card;
    }
    renderExplore() {
      const explore = node('section', 'wj-finder__explore'); explore.append(node('h3', '', this.t('explore_heading')), node('p', '', this.t('explore_desc')));
      const chips = node('div', 'wj-finder__chips');
      const categories = this.availableCategories().filter(item => !this.state.categories.includes(item.id));
      categories.slice(0, 6).forEach(category => { const button = this.button(category.title, 'direction', 'wj-finder__chip'); button.append(icon('arrow')); button.dataset.category = category.id; chips.append(button); });
      if (this.state.categories.length) chips.append(this.button(this.t('all_directions'), 'broaden', 'wj-finder__chip'));
      const browse = this.link(this.t('browse'), this.dataset.allUrl, 'wj-finder__chip'); browse.append(icon('arrow')); chips.append(browse);
      for (const id of this.state.categories) { const category = this.categories.find(item => item.id === id); if (category) { const link = this.link(this.t('category_link', {category: category.title}), category.url, 'wj-finder__chip'); link.append(icon('arrow')); chips.append(link); } }
      explore.append(chips); this.panel.append(explore);
    }
    syncSaves() {
      const ids = window.WohnjoyWishlist?.readIds() || [];
      this.querySelectorAll('[data-wj-action="save"]').forEach(button => { const saved = ids.includes(button.dataset.productId); button.setAttribute('aria-pressed', String(saved)); button.setAttribute('aria-label', this.t(saved ? 'unsave' : 'save')); });
    }
    save(button) {
      const state = window.WohnjoyWishlist; if (!state) return;
      const ids = state.readIds(); const id = button.dataset.productId; const saved = ids.includes(id);
      const success = state.setIds(saved ? ids.filter(value => value !== id) : [...ids, id], 'finder');
      if (success && !saved) state.remember(id, button.dataset.variantId);
      this.syncSaves(); this.status.textContent = this.t(success ? saved ? 'removed' : 'saved' : 'save_error');
    }
    async share(button) {
      try { await navigator.clipboard.writeText(location.href); button.replaceChildren(icon('share'), document.createTextNode(this.t('shared'))); this.status.textContent = this.t('shared'); }
      catch { this.status.textContent = this.t('share_error'); const note = node('p', 'wj-finder__result-note', this.t('share_error')); button.after(note); }
    }
  }
  customElements.define('wohnjoy-finder', WohnjoyFinder);
})();
